// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__KFGKE","inner":"Footer_inner__1LhR_","nextIcon":"Footer_nextIcon__3FFc3","innerLeft":"Footer_innerLeft__WIW6g"};